export enum INVITE_SORT {
  CREATED_AT = 'createdAt',
  ROLE = 'role',
  GROUP = 'group',
  CREATED_BY = 'createdBy',
}
